<template>
  <HeadUp :toHome="toHome"></HeadUp>
  <div class="intro">
    <div class="step-title">注册账号</div>

    如果您的 狗急加速 与下图不一致 <br>
    请先升级 APP
    <br>
    <br>
    <div class="step-number">1</div>
    <div>
      &nbsp;如果您是游客
      <br>
      打开 APP，在侧边栏点击【注册】
      <br>
      <img class="step-screenshot" src="@/assets/images/mail_bind_1.png">
      <br>
      <div>
        如果您是 VIP 会员
        <br>
        请在侧边栏点击【绑定邮箱】
        <br>
        <img class="step-screenshot" src="@/assets/images/mail_bind_2.png">
      </div>
    </div>
    <div class="step-number">2</div>

    <div><span>跟随引导，完成邮箱验证即可</span></div>
    <br>
    <div class="step-button" @click="back">返回</div>
    <br><br>
  </div>
  <div class="flex-item"></div>
  <Footer></Footer>
</template>

<script>
  import { useRouter } from 'vue-router'
  import { useStore } from "vuex"

  import HeadUp from '../components/Head.vue'
  import Footer from '../components/Footer.vue'

  import utils from '../utils/utils'
  import {getDomain} from "@/config";
  export default {
    name: 'GuideMailBind',
    components: {
      Footer,
      HeadUp
    },
    setup () {
      let store = useStore().state
      function setTitle (lang) {
        document.title = store.languages[lang]['title']
      }
      function getTitle () {
        this.$http.get(`${getDomain('oc')}/api/website/vue/lpt-title`)
          .then(data => {
            const _data = data.data.obj
            Object.keys(_data).forEach(k => {
              store.languages[k]['title'] = _data[k]
            })
            setTitle(store.lang)
          })
          .catch(err => {
            console.log(err)
          })
      }

      function downloadNow(){
        let url = `goj/apks/latest/goj-latest-release-${utils.getQuery('from') || 'official'}.apk`
        utils.download(url)
      }

      function toHome(){
        window.location.href = `${utils.getQuery('from') || 'index'}.html`
      }
      let router = useRouter()

      function back () {
        router.go(-1)
      }

      return {
        store,
        getTitle,
        setTitle,
        downloadNow,
        toHome,
        back
      }
    },
    created () {
      this.getTitle()
      let lang = utils.getCookie('lang')
      useStore().commit('change', (lang || 'zh'))
      this.setTitle(this.store.lang)
      let html = document.getElementsByTagName('html')[0]
      utils.bindBGCEvent(html, 'white', '#000000')
      utils.creatCutomerService()
    }
  }
</script>

<style>
  *{
    padding: 0;
    margin: 0;
  }
  body, html {
    font-size: 12px;
  }
  body {
    font-family: Roboto,sans-serif;
    font-weight: 700;
    height: 100%;
    z-index: -1;
    width: 100%;
  }
  ul {
    list-style: none;
  }
  .intro {
    background-color: white;/* Todo: Try to remove this since unreasonable */
    padding: 6rem 0 2rem 0;
    font-size: 1.2rem;
    text-align: center;
  }

  .intro span {
    display: inline-block;
    vertical-align: middle;
  }

  .intro ul {
    text-align: center;
  }

  .intro a:hover,
  .intro a:link,
  .intro a:visited,
  .intro a:active {
    color: #0066FF;
    text-decoration: underline;
  }

  .intro .step-title {
    background-color: #CC1424;
    color: white;
    width: 70%;
    max-width: 500px;
    margin: 0 auto 1.2rem auto;
    padding: 0.25rem;
    font-size: 1.5rem;
    border: 3px solid #4D2C22;
    border-radius: 10rem;
    box-shadow: 0 4px 0 0 #00000030;
    -webkit-box-shadow: 0 4px 0 0 #00000030;
    -moz-box-shadow: 0 4px 0 0 #00000030;
  }

  .intro .step-box {
    display: block;
    background-color: #EEEEEE;
    color: black;
    width: 70%;
    max-width: 500px;
    margin: 0 auto 1.2rem auto;
    padding: 1.5rem;
    font-size: 1.2rem;
    border: 3px solid #4D4D4D;
    border-radius: 2rem;
    box-shadow: inset 0 4px 0 0 white, 0 4px 0 0 #00000030;
    -webkit-box-shadow: inset 0 4px 0 0 white, 0 4px 0 0 #00000030;
    -moz-box-shadow: inset 0 4px 0 0 white, 0 4px 0 0 #00000030;
  }

  .intro .step-box hr {
    margin: 1.5rem;
    border: 0;
    border-top: 2px dotted lightgrey;
  }

  .intro .step-number {
    background-color: black;
    color: white;
    border-radius: 10rem;
    border: none;
    margin: auto auto 1.2rem auto;
    width: 2.2rem;
    height: 2.2rem;
    line-height: 2.2rem;
    font-size: 1.2rem;
    text-align: center;
  }

  .intro .step-comment {
    font-size: 1rem;
    color: darkgrey;
  }

  .intro .step-screenshot {
    width: 60%;
    max-width: 265px;
    border-radius: 2rem;
    border: 1px dotted lightgrey;
    margin: 1rem auto 3rem auto;
  }

  .intro .app-store-like .app-icon {
    height: 6rem;
    margin-right: .5rem;
    border-radius: 1.4rem;
    display: block;
  }

  .intro .app-store-like ul {
    text-align: left;
  }

  .intro .app-store-like .app-title {
    color: black;
    font-size: 1.5rem;
  }

  .intro .app-store-like .app-intro {
    color: #999999;
    margin-bottom: 0.2rem;
    font-size: 1rem;
  }

  .intro .app-store-like .app-get, .intro .step-button, .intro a.step-button {
    background-color: #0066FF;
    border-radius: 20rem;
    border: none;
    color: white;
    padding: 0.2rem 1.2rem;
    display: inline-block;
    font-size: 1.2rem;
    cursor: pointer;
    text-decoration: none;
  }

  .intro .app-store-like .app-get.unpaid {
    background-color: #b2b2b2;
  }

  .intro .pub-app-id-acc-flex-wrapper {
    width: 80%;
    max-width: 600px;
    margin: auto;
    text-align: left;
    line-height: 3rem;
    border: 0;
    border-top: 1px dotted lightgrey;
    display: flex;
  }

  .intro .pub-app-id-acc, .intro .pub-app-id-psw {
    flex: 1;
  }

  .intro .pub-app-id-acc-cp, .intro .pub-app-id-psw-cp {
    color: #0066FF;
    /*text-decoration: underline;*/
  }
</style>
